import { FC } from 'react';
import { Button, Modal } from '@components/index';
import { TrashIcon } from '@icons/index';

import styles from './index.module.scss';

interface DeleteDemandModalProps {
  showModal: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  description?: string;
  cancelText?: string;
  confirmText?: string;
}

/**
 * @description A reusable and dynamic modal for deleting a record.
 * Props:
 * - showModal: boolean - a condition to render our modal
 * - onCancel: function - a fn to call on modal cancelation
 * - onConfirm: function - a fn to call on modal confirmation
 * - title: string - Title of the modal
 * - description: string - Description message inside the modal
 * - cancelText: string - Text for the cancel button
 * - confirmText: string - Text for the confirm button
 */
const DeleteModal: FC<DeleteDemandModalProps> = (props) => {
  const {
    showModal,
    onCancel,
    onConfirm,
    title = 'Delete record',
    description = `Are you sure you want to delete this record`,
    cancelText = 'Cancel',
    confirmText = 'Yes, delete',
  } = props;

  return (
    <Modal showModal={showModal}>
      <div className={styles.layout}>
        <div className={styles.trashIcon}>
          <TrashIcon stroke="#D92D20" />
        </div>
        <p className={styles.title}>{title}</p>
        <p
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
        <div className={styles.actions}>
          <Button onClick={onCancel}>{cancelText}</Button>
          <Button onClick={onConfirm} variant="danger">
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
